var map = {
	"./84-nap-1.jpg": "9589",
	"./84-nap-logo.png": "a8c2",
	"./akitogogon-1.jpg": "c64d",
	"./akitogogon-2.jpg": "9611",
	"./akitogogon-3.jpg": "f075",
	"./eu-1.jpg": "f486",
	"./eu-2.jpg": "4252",
	"./eu-3.jpg": "6782",
	"./eu-4.jpg": "a39c",
	"./graduate-a-girl-projekt-1.jpg": "6f1c",
	"./gyermektamogatas-projekt-1.jpg": "5063",
	"./gyermektamogatas-projekt-2.jpg": "8d89",
	"./iskolafejlesztes-1.jpg": "23a7",
	"./iskolafejlesztes-2.jpg": "ff65",
	"./logo-shanita.png": "162b",
	"./mtwapa.jpg": "d0f3",
	"./noi-program-1.jpg": "0866",
	"./noi-program-2.jpg": "a4a1",
	"./noi-program-3.jpg": "02a0",
	"./noi-program-4.jpg": "fe7a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8763";